const StorageLocation = () => {

  return (
    <>
      <div className="p-4">
        Storage & Location Tab Details is coming soon...
      </div>
    </>
  );
};

export default StorageLocation;
